export default __webpack_public_path__ + "static/metamask-hero-17fa0557fe56ed3f1dcf2443f86c003c.png";